/**
 * Implements a top-menu route interceptor as a behavior. It manages modals
 * requested from the top menu.
 *
 * It must attached to the main layout.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import { createModal } from "../utils";

import AccountDetailsView from "../views/account-details/";
import HealthcheckSettingsView from "../views/healthcheck/settings";
import RoleSelectorView from "../views/role-selector";

const channel = Radio.channel("global");

class GlobalBehaviors extends Marionette.Behavior {
  initialize() {
    // remove `loading` class from body
    $("body").removeClass("loading");

    this.listenTo(channel, "user-details", this.onUserDetails);
    this.listenTo(
      channel,
      "tools.healthcheck-settings",
      this.onHealthcheckSettings
    );
    this.listenTo(channel, "tools.role-selector", this.onRoleSelector);
    this.listenTo(channel, "user.signout", this.onSignout);
    this.listenTo(channel, "environment.selection", this.onSelectEnvironment);
    this.listenTo(channel, "display:error", this.displayError);
    this.listenTo(channel, "top-menu", this.onTopMenuEvent);
  }

  onUserDetails() {
    new AccountDetailsView({
      el: createModal(),
    });
  }

  onHealthcheckSettings() {
    new HealthcheckSettingsView({
      el: createModal(),
    });
  }

  onRoleSelector() {
    new RoleSelectorView({
      el: createModal(),
    });
  }

  onSignout() {
    channel.trigger("auth:signout");
  }

  onSelectEnvironment() {
    channel.trigger("auth:display-shards");
  }

  // Default error display handler. Override to make it more robust.
  displayError(message) {
    console.error(message);
  }

  onTopMenuEvent(model) {
    // route thru old system
    channel.trigger(model.get("route"), model);
  }
}

export { GlobalBehaviors as default };
